export default "__VITE_ASSET__U06ChLbi__"